module.exports = __webpack_public_path__ + "static/media/human1.7761258f.jpg";